import React, { useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Link } from '../../../../../UI/Elements/Link';
import { IProduct } from '../../../../../utils/types/contentful';
import { Button } from '../../../../../UI/Elements';

export interface ProductPackMainRecommendationsProps {
  product: IProduct;
}

export const ProductPackMainRecommendation = ({ label, subLabel, product }) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <Link slug={product?.slug}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className={`w-full ${
          isHover ? 'bg-gray-100' : 'bg-white'
        } transform transition duration-300 flex justify-between items-center border my-3 p-2`}>
        <div>
          <Label
            {...label}
            size='base'
            weight='medium'
          />
          <Label
            {...subLabel}
            weight='light'
          />
        </div>
        <Button
          type={isHover ? 'contained' : 'outlined'}
          color={{ classname: 'primary' }}
          icon={{
            iconKey: 'HiOutlineChevronRight',
          }}
        />
      </div>
    </Link>
  );
};

export const ProductPackMainRecommendations: React.FC<
  ProductPackMainRecommendationsProps
> = ({ recommendations }) => (
  <div className='w-full border-b border-t'>
    <div className='my-3'>
      <Label
        {...recommendations.header}
        color={{ classname: 'gray-800' }}
        weight='medium'
      />
    </div>
    <div className='pb-1'>
      {recommendations.gridItems.map((item) => (
        <ProductPackMainRecommendation
          {...item}
          isMini
        />
      ))}
    </div>
  </div>
);
